import { React, classNames, withStyles, StyledProps } from '@api'
import { ListItem, ListItemText } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { PrimaryIconButton, CentricTheme } from 'centric-ui-components'

const styles = (theme: CentricTheme) => ({
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    paddingBottom: theme.spacing() * 2,
    paddingLeft: theme.spacing() * 3,
    backgroundColor: '#FFF',
    '&:nth-child(even)': {
      backgroundColor: 'rgba(0,0,0, 0.05)'
    }
  },
  content: {
    flex: 1,
    justifyContent: 'flex-start',
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  userDate: {
    fontSize: 12,
    color: 'rgba(27, 27, 27, 0.54)'
  },
  userName: {
    fontSize: 12,
    color: 'rgba(27, 27, 27, 0.54)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginRight: 8
  },
  textItem: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 0,
    whiteSpace: 'nowrap'
  },
  subject: {
    fontSize: 14,
    color: 'rgba(27, 27, 27, 0.87)',
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  title: {
    fontSize: 14,
    color: 'rgba(27, 27, 27, 0.87)',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  body: {
    fontSize: 14,
    color: 'rgba(27, 27, 27, 0.54)',
    fontWeight: 'normal',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkitLineClamp': 3,
    '-webkitBoxOrient': 'vertical',
    paddingTop: theme.spacing()
  },
  moreIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    '& svg': {
      width: 18,
      height: 18
    }
  }
})

interface MyProps extends StyledProps {
  comment: any,
  onClickMoreMenu: (e, commentId, productId) => void
}

@(withStyles as any)(styles)
export class NoteItem extends React.Component<MyProps> {
  static defaultProps = {
    rowsMax: 5
  }

  render() {
    const {
      props : {
        comment,
        classes,
        onClickMoreMenu
      }
    } = this

    return (
      <ListItem key={comment.id} className={classes.listItem}>
        <div className={classes.content}>
          <ListItemText classes={{primary: classes.userName}} primary={comment.username}/>
          <ListItemText primary={comment.timeAgo} classes={{root: classes.textItem, primary: classes.userDate}}/>
          <PrimaryIconButton
            icon={<MoreVert/>}
            className={classes.moreIcon}
            onClick={(e) => { onClickMoreMenu(e, comment.id, comment.product.id) }}
          />
        </div>
        {comment.description ? <div className={classes.content}>
          <ListItemText primary={`${comment.description}`}/>
        </div> : null}
        <div className={classes.content}>
          <ListItemText primary={`${comment.subject}`} classes={{primary: classes.subject}} title={comment.subject}/>
        </div>
        <div className={classes.content}>
          <ListItemText classes={{primary: classes.body}} primary={comment.comment} title={comment.comment}/>
        </div>
      </ListItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/NoteItem.tsx